import { useEffect, useState } from "react";

export function useServerYear() {
    const [year, setYear] = useState(null);

    useEffect(() => {
        async function fetchYear() {
            try {
                const res = await fetch(window.location.origin, { method: "HEAD" });
                const dateHeader = res.headers.get("date");

                if (dateHeader) {
                    const serverYear = new Date(dateHeader).getFullYear();
                    setYear(serverYear);
                }
            } catch (err) {
                console.error("Failed to fetch server year:", err);
            }
        }

        fetchYear();
    }, []);

    return year;
}